<template>
  <el-card
    class="integration-card"
    :body-style="{ padding: '0px', backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column', height: '100%' }">
    <img :src="image" class="integration-image" @error="onImageError">
    <div class="integration-card-content">
      <div class="integration-title-row">
        <span class="integration-title">Configure a integração com a {{ title }}</span>
      </div>
      <span class="integration-updated-at">Última atualização: <span class="integration-updated-value">{{ updatedAt }}</span></span>
      <div class="bottom clearfix">
        <el-button :disabled="!options.find(x => x === 'object')" title="Objeto" type="text"><i
            class="el-icon-s-order"></i></el-button>
        &nbsp;
        <el-button :disabled="!options.find(x => x === 'customer')" title="Cliente" type="text"><i
            class="el-icon-user-solid"></i></el-button>
      </div>
      <div class="bottom clearfix integration-actions">
        <el-button-group class="w-100">
          <el-button class="w-50" type="default" @click="$emit('configure')" icon="el-icon-setting">Configurar</el-button>
          <el-button class="w-50" type="default" :disabled="!id" @click="logs" icon="el-icon-s-order">Logs</el-button>
          <!--el-button class="w-33" type="default" :disabled="!toutbox.id" @click="execute" icon="el-icon-finished">Executar</!--el-button-->
        </el-button-group>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  props: ["image", "title", "status", "updatedAt", "options", "id"],
  data() {
    return {
      placeholderImage: '/img/integration/logo-placeholder.svg',
    };
  },
  methods: {
    logs: function () {
      const vm = this;
      this.$router.push({
        name: 'integration.logs',
        params: { id: vm.id },
      })
    },
    onImageError(event) {
      const img = event && event.target;
      if (!img || img.dataset.placeholderApplied) return;
      img.dataset.placeholderApplied = 'true';
      img.src = this.placeholderImage;
    },
  },
}
</script>
<style scoped>
.integration-card {
  height: 100%;
  position: relative;

}

.integration-image {
  margin: 8px 0 0 8px;
  height: 40px;
  width: auto;
  max-width: calc(100% - 16px);
  display: block;
  align-self: flex-start;
  object-fit: contain;
}

.integration-card-content {
  padding: 14px;
  background-color: #fff;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.integration-title-row {
  min-height: 56px;
  padding-right: 18px;
}

.integration-title {
  line-height: 1.4;
}

.integration-updated-at {
  font-size: 12px;
}

.integration-updated-value {
  font-size: 12px;
  color: #66b1ff;
}

.integration-actions {
  margin-top: auto;
}
</style>
